import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpdchartService {
  private _chartDataCache: { [key: string]: any } = {};

  constructor(private http: HttpClient) { }

  clearCache() {
    this._chartDataCache = {};
  }

  createOpdChartData(data:any): Observable<any> {
    this.clearCache();
    return this.http.post(environment.createOpdChartData,data);
  }

  getAllOpdChartData(data:any): Observable<any> {
    const patientId = data?.where?.patient_id;
    if (patientId && this._chartDataCache[patientId]) {
      return of(this._chartDataCache[patientId]);
    }

    // Always fetch all attributes to ensure cache contains full EMR chart data
    if (data && data.attributes) {
      data.attributes = [
        'id', 'app_id', 'hospital_id', 'patient_id', 'center_id',
        'medications', 'diagnosis', 'primary_checkups', 'investigations',
        'ophthalmic_examinations', 'advices', 'createdAt'
      ];
    }

    return this.http.post(environment.getAllOpdChartData,data).pipe(
      tap(res => {
        if (patientId && res) {
          this._chartDataCache[patientId] = res;
        }
      })
    );
  }

  updateOpdChartData(data:any): Observable<any> {
    this.clearCache();
    return this.http.post(environment.updateOpdChartData,data);
  }

  createMedicationTemplate(data:any): Observable<any> {
    return this.http.post(environment.createMedicationTemplate,data);
  }
  getMedicationTemplate(data:any): Observable<any> {
    return this.http.post(environment.getMedicationTemplate,data);
  }

  createInvestigationTemplate(data:any): Observable<any> {
    return this.http.post(environment.createInvestigationTemplate,data);
  }
  getInvestigationTemplate(data:any): Observable<any> {
    return this.http.post(environment.getInvestigationTemplate,data);
  }
  getAllPriceMaster(data:any): Observable<any> {
    return this.http.post(environment.getAllPriceMaster,data);
  }
  getAdviceTemplate(data:any): Observable<any> {
    return this.http.post(environment.getAdviceTemplate,data);
  }

  sharePrescription(data:any): Observable<any> {
    return this.http.post(environment.sharePrescription,data);
  }
}
